(function(){
  /* ==========================================================
     CONFIG. Comes from Theme settings, MonaVie (rendered into #mv-data
     by snippets/mv-data.liquid).
     klaviyo    Public company id (site id) and the list id for the
                email sign up form.
     Prices, plans, gifts and Shopify variant / selling plan ids live
     in the PDP widget (assets/monavie-pdp.js), built from Shopify data.
     ========================================================== */
  var DATA=(function(){try{return JSON.parse(document.getElementById('mv-data').textContent)||{}}catch(e){return {}}})();
  var CONFIG={
    klaviyo:{companyId:(DATA.klaviyo&&DATA.klaviyo.companyId)||'', listId:(DATA.klaviyo&&DATA.klaviyo.listId)||''}
  };

  var body=document.body;

  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return [].slice.call((r||document).querySelectorAll(s))}
  function money(n){return '$'+(Math.round(n*100)%100 ? n.toFixed(2) : Math.round(n))}
  var ICON={
    check:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>',
    truck:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1 4h14v12H1z"/><path d="M15 9h4l3 3v4h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>'
  };

  /* Links anywhere on the page that pick a format (and optionally a plan) before scrolling to the buy box.
     On pages without the buy box (contact, accessibility) they go to the homepage deep link instead. */
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-pick-format]'); if(!a) return;
    if(window.MVPDP && window.MVPDP.hasWidget) window.MVPDP.pick(a.dataset.pickFormat, a.dataset.pickPlan);
    else { e.preventDefault(); location.href='/?format='+encodeURIComponent(a.dataset.pickFormat)+(a.dataset.pickPlan==='sub'?'&plan=sub':''); }
    closeShopPanel();
  });

  /* ---------- cart ----------
     Lines come from the PDP widget (MVPDP.lines). Each line carries its
     Shopify variant, selling plan and properties (format, plan, purchase
     type) and is sent to the Shopify Ajax cart. /cart.js does not return
     the display fields (gift rows, images, free shipping, upgrade), so
     Cart.load rebuilds them with MVPDP.fromCart from the line item
     properties and the widget config. */
  function shopifyItem(l){
    var it={id:Number(l.variant), quantity:l.qty||1, properties:l.properties||{}};
    if(l.sellingPlan) it.selling_plan=Number(l.sellingPlan);
    return it;
  }
  function post(url,data){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)})
      .then(function(r){ return r.json().catch(function(){return {}}).then(function(j){ if(!r.ok) throw new Error(j.description||j.message||(url+' failed')); return j; }); });
  }

  var Cart={
    items:[],
    load:function(tidied){
      return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
                var fix=(!tidied && window.MVPDP) ? window.MVPDP.giftFixes(c.items) : null;
        if(fix) return post('/cart/update.js',{updates:fix}).then(function(){ return Cart.load(true); });
        Cart.items=window.MVPDP ? window.MVPDP.fromCart(c.items) : [];
      });
    },
    add:function(lines){
      var main=lines[0];
      var items=lines.filter(function(l){return !l.info}).map(function(l){
        if(!l.variant) throw new Error('Missing Shopify variant id for '+l.title);
        if(l.properties && l.properties['Purchase type']==='Subscription' && !l.sellingPlan) throw new Error('Missing Seal selling plan for '+l.title+', '+l.detail);
        return shopifyItem(l);
      });
      return post('/cart/add.js',{items:items}).then(function(){
        track('Added to Cart',{ProductName:main.title, ProductID:main.productId, VariantID:Number(main.variant), Variant:main.detail, Plan:main.properties&&main.properties.Plan, PurchaseType:main.planLabel, Price:main.unit, ImageURL:absUrl(main.img), URL:location.origin+'/'});
      }).then(function(){ return Cart.load(); });
    },
    change:function(key,qty){
      return post('/cart/change.js',{id:key,quantity:qty}).then(function(){ return Cart.load(); });
    },
    swap:function(key,lines){ return Cart.change(key,0).then(function(){ return Cart.add(lines); }); }
  };

  function renderCart(){
    var items=Cart.items, bodyEl=$('#cart-body'), foot=$('#cart-foot');
    var paid=items.filter(function(i){return !i.gift}), gifts=items.filter(function(i){return i.gift});
    var seenGift={}; gifts=gifts.filter(function(g){var k=g.key.split('|').pop(); if(seenGift[k]) return false; seenGift[k]=1; return true;});  /* each gift shows once, even with several subscriptions */
    var count=paid.reduce(function(n,i){return n+i.qty},0);
    var badge=$('.cart-count'); badge.textContent=count; badge.hidden=!count;
    $('.cart-btn').setAttribute('aria-label','Open cart, '+count+' item'+(count===1?'':'s'));
    $('#cart-items').textContent=count?'('+count+' item'+(count===1?'':'s')+')':'';
    if(!items.length){
      bodyEl.innerHTML='<div class="cart-empty"><div class="c-empty-img"><img src="//monavie.shop/cdn/shop/t/22/assets/mv-format-shots.png?v=168672558153026815121790702393" alt=""></div><p>Your cart is empty.</p><a class="btn btn-primary" href="'+(window.MVPDP&&window.MVPDP.hasWidget?'':'/')+'#buy" data-pick-format="shots" data-close>Shop the new shot</a></div>';
      foot.hidden=true; return;
    }
    var free=paid.length && paid.every(function(i){return i.freeShip});
    var realG=gifts.filter(function(g){return !/\|ship$/.test(g.key)});
    var shipFee=paid.reduce(function(n,i){return Math.max(n,i.freeShip?0:(i.shipFee||0))},0);
    var html=free
      ? '<div class="c-banner ok"><span class="c-bi">'+ICON.truck+'</span><div><b>Congrats! Free shipping unlocked</b><span>Plus '+(realG.length?realG.length+' free gift'+(realG.length===1?'':'s')+' with your order':'free shipping on every delivery')+'</span></div></div>'
      : '<div class="c-banner"><span class="c-bi">'+ICON.truck+'</span><div><b>Want free shipping?</b><span>It comes with every subscription</span></div></div>';
    html+=paid.map(function(i){
      var line=i.unit*i.qty, save=Math.max(0,(i.was-i.unit)*i.qty);
      return '<div class="c-line">'+
        '<div class="c-thumb">'+(i.img?'<img src="'+i.img+'" alt="">':'')+'</div>'+
        '<div class="c-info"><b class="c-title">'+i.title+'</b><span class="c-det">'+i.detail+'</span>'+(i.planLabel?'<span class="c-plan">'+i.planLabel+'</span>':'')+
          '<div class="c-row"><div class="qty"><button type="button" data-q="'+i.key+'" data-d="-1" aria-label="Decrease quantity">−</button><span>'+i.qty+'</span><button type="button" data-q="'+i.key+'" data-d="1" aria-label="Increase quantity">+</button></div>'+
          '<button type="button" class="c-rm" data-q="'+i.key+'" data-d="rm" aria-label="Remove '+i.title+'"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button></div>'+
          (save?'<span class="c-save">'+ICON.check+'You save '+money(save)+'</span>':'')+
        '</div>'+
        '<div class="c-price">'+(save?'<s>'+money(i.was*i.qty)+'</s>':'')+'<b>'+money(line)+'</b></div></div>';
    }).join('');
    var up=paid.filter(function(i){return i.upgrade})[0];
    if(up && window.MVPDP){
      var info=window.MVPDP.upgradeInfo(up.upgrade.fmt, up.upgrade.plan);
      html+='<div class="c-up"><div class="c-up-gifts">'+info.imgs.map(function(u){return '<span><img src="'+u+'" alt=""></span>'}).join('')+'</div>'+
        '<div class="c-up-txt"><b>'+(up.once?'Subscribe and save':'Upgrade to the '+info.name)+'</b><span>'+info.pitch+'</span></div>'+
        '<button type="button" class="c-up-btn" data-up="'+up.key+'">'+up.upgrade.label+'</button></div>';
    }
    if(gifts.length){
      var gv=gifts.reduce(function(n,i){return n+(i.was||0)},0);
      html+='<div class="c-gifts"><div class="c-gh"><b>Your free gifts</b><span>'+(gv?money(gv)+' value':'With your first order')+'</span></div>'+
        gifts.map(function(g){
          return '<div class="c-gift"><div class="c-thumb sm">'+(g.img?'<img src="'+g.img+'" alt="">':'')+'</div>'+
            '<div class="c-info"><b class="c-title">'+g.title+'</b><span class="c-det">'+g.detail+'</span></div>'+
            '<div class="c-price"><span class="c-free">Free</span>'+(g.was?'<s>'+money(g.was)+'</s>':'')+'</div></div>';
        }).join('')+'</div>';
    }
    bodyEl.innerHTML=html;
    var sub=paid.reduce(function(n,i){return n+i.unit*i.qty},0);
    var saved=paid.reduce(function(n,i){return n+Math.max(0,(i.was-i.unit)*i.qty)},0)+gifts.reduce(function(n,i){return n+(i.was||0)},0);
    var total=sub+(free?0:shipFee);
    $('#cart-saved-row').hidden=!saved; $('#cart-saved').textContent=money(saved);
    $('#cart-ship').innerHTML=free?'<span class="c-freeship">Free</span>':(shipFee?money(shipFee):'At checkout');
    $('#cart-subtotal').textContent=money(total);
    $('#cart-cta').textContent='Secure checkout · '+money(total);
    $('#cart-note').textContent='Taxes calculated at checkout.';
    foot.hidden=false;
  }

  $('#cart-body').addEventListener('click',function(e){
    var b=e.target.closest('[data-q]');
    if(b){
      var it=Cart.items.filter(function(i){return i.key===b.dataset.q})[0]; if(!it) return;
      var q=b.dataset.d==='rm'?0:it.qty+Number(b.dataset.d);
      cartOp(function(){ return Cart.change(it.key,Math.max(0,q)); }); return;
    }
    var up=e.target.closest('[data-up]');
    if(up && window.MVPDP){
      var cur=Cart.items.filter(function(i){return i.key===up.dataset.up})[0]; if(!cur) return;
      var u=cur.upgrade;
      cartOp(function(){ return Cart.swap(cur.key, window.MVPDP.lines(u.fmt,u.plan,false)); });
    }
  });
  /* Quantity, remove and upgrade. One at a time, and a failed call shows a note instead of a stale cart. */
  var cartBusy=false;
  function cartOp(fn){
    if(cartBusy) return; cartBusy=true; $('#cart-body').setAttribute('aria-busy','true');
    var p; try{ p=fn(); }catch(err){ p=Promise.reject(err); }
    p.then(renderCart,function(err){
      console.error(err);
      return Cart.load().catch(function(){}).then(function(){ renderCart(); $('#cart-note').textContent='Something went wrong updating your cart. Please try again.'; });
    }).then(function(){ cartBusy=false; $('#cart-body').removeAttribute('aria-busy'); });
  }
  /* Checkout is a plain link to /checkout. Shopify's customer events report Begin checkout to the Meta pixel and GA4. */

  /* Used by the PDP widget */
  window.MVCart={
    add:function(lines){
      return Cart.add(lines).then(function(){ renderCart(); openDrawer('cart'); });
    }
  };

  /* ---------- timeline progress line ----------
     Desktop draws the line once when the section comes into view.
     Mobile (stacked) fills the vertical line as you scroll. */
  (function(){
    var tl=$('#tl'); if(!tl) return;
    var steps=$$('.step',tl), ticking=false, mq=window.matchMedia('(max-width:900px)');
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(e){ if(e[0].isIntersecting) tl.classList.add('play'); },{threshold:0.35}).observe(tl);
    } else tl.classList.add('play');
    function update(){
      ticking=false;
      if(!mq.matches){ steps.forEach(function(s){s.style.removeProperty('--f'); s.classList.remove('lit')}); return; }
      var r=tl.getBoundingClientRect(), vh=window.innerHeight;
      var p=Math.min(1,Math.max(0,(vh*0.75-r.top)/(r.height*0.92)));
      var n=steps.length-1, pos=p*n;
      steps.forEach(function(s,i){
        s.style.setProperty('--f',Math.min(1,Math.max(0,pos-i)).toFixed(3));
        s.classList.toggle('lit',pos>=i-0.02 && p>0);
      });
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll);
    update();
  })();

  /* ---------- reviews preview ---------- */
  function stars(n){var s='';for(var i=1;i<=5;i++)s+='<span class="'+(i<=n?'':'off')+'">★</span>';return s}
  function esc(t){return String(t==null?'':t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function initials(n){return esc(String(n||'?').split(/\s+/).map(function(w){return w.charAt(0)}).join('').slice(0,2).toUpperCase())}
  function reviewCard(r){
    return '<article class="rcard2">'+
      '<header><span class="ravatar">'+initials(r.name)+'</span><div><b>'+esc(r.name)+'</b>'+(r.verified?'<span class="rverified">'+ICON.check+'Verified purchase</span>':'')+'</div></header>'+
      '<div class="rstars" aria-label="'+r.rating+' out of 5 stars">'+stars(r.rating)+'</div>'+
      (r.title?'<h3>'+esc(r.title)+'</h3>':'')+
      '<p class="rbody">'+esc(r.body)+'</p>'+
      (r.photos?'<div class="rphotos">'+r.photos.map(function(u){return '<img src="'+esc(u)+'" alt="Customer photo from '+esc(r.name)+'" loading="lazy">'}).join('')+'</div>':'')+
    '</article>';
  }
  /* Photos in the reviews file are theme asset names, full URLs are kept as they are */
  function photoUrl(u){ return /^(https?:)?\/\//.test(u) ? u : (window.MV && window.MV.assets || '') + u; }
  if($('#rlist')) fetch(window.MV && window.MV.reviewsUrl).then(function(r){return r.json()}).catch(function(){return {reviews:[]}}).then(function(d){
    var all=(d.reviews||[]).filter(function(r){return !r.hidden}).map(function(r){ if(r.photos) r.photos=r.photos.map(photoUrl); return r; }); var feat=all.filter(function(r){return r.featured}); var list=(feat.length>=6?feat:all).sort(function(a,b){return (b.featured?1:0)-(a.featured?1:0)||b.rating-a.rating});
    var el=$('#rlist'), bar=$('#rbar');
    el.innerHTML=list.slice(0,10).map(reviewCard).join('');
    function prog(){ var max=el.scrollWidth-el.clientWidth, vis=el.clientWidth/el.scrollWidth; bar.style.width=(vis*100)+'%'; bar.style.marginLeft=(max>0?(el.scrollLeft/max)*(100-vis*100):0)+'%'; }
    el.addEventListener('scroll',function(){requestAnimationFrame(prog)},{passive:true});
    window.addEventListener('resize',prog); prog();
    $$('[data-rdir]').forEach(function(b){b.addEventListener('click',function(){
      var c=el.querySelector('.rcard2'), step=c?c.getBoundingClientRect().width+16:320;
      el.scrollBy({left:Number(b.dataset.rdir)*step,behavior:'smooth'});
    })});
  });

  /* ---------- drawers and modal ---------- */
  var lastFocus=null;
  function openDrawer(id){
    var d=document.getElementById(id); if(!d) return;
    lastFocus=document.activeElement;
    d.hidden=false; body.classList.add('locked');
    requestAnimationFrame(function(){d.classList.add('open')});
    var f=d.querySelector('.x'); if(f) f.focus();
    if(id==='drawer') $('.menu-btn').setAttribute('aria-expanded','true');
  }
  function closeDrawer(d){
    if(!d||d.hidden) return;
    d.classList.remove('open'); body.classList.remove('locked');
    setTimeout(function(){d.hidden=true},260);
    if(d.id==='drawer') $('.menu-btn').setAttribute('aria-expanded','false');
    if(lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
  }
  $$('.drawer').forEach(function(d){
    d.addEventListener('click',function(e){ if(e.target.closest('[data-close]')) closeDrawer(d); });
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){ $$('.drawer').forEach(closeDrawer); closeShopPanel(); }
  });
  $('.menu-btn').addEventListener('click',function(){openDrawer('drawer')});
  $('.cart-btn').addEventListener('click',function(){renderCart(); openDrawer('cart')});
  $$('[data-open-facts]').forEach(function(b){b.addEventListener('click',function(){ var m=document.getElementById('all-ing'); if(m && !m.hidden){ m.classList.remove('open'); m.hidden=true; } openDrawer('facts'); })});
  $$('[data-open-ing]').forEach(function(b){b.addEventListener('click',function(){openDrawer('all-ing')})});

  /* ---------- ingredient rail, slow auto scroll that pauses on hover, touch or focus ---------- */
  (function(){
    var rail=$('#irail'); if(!rail) return;
    /* Phones and tablets get clean manual swiping with snap, desktop gets the slow auto scroll */
    var touch=window.matchMedia('(hover: none), (max-width: 760px)').matches;
    if(!touch) [].slice.call(rail.children).forEach(function(c){ var k=c.cloneNode(true); k.setAttribute('aria-hidden','true'); rail.appendChild(k); });
    var reduce=touch || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bar=$('#iprog');
    function prog(){
      var total=touch?rail.scrollWidth:rail.scrollWidth/2, vis=Math.min(1,rail.clientWidth/total);
      var at=(rail.scrollLeft%total)/total;
      bar.style.width=(vis*100)+'%'; bar.style.marginLeft=(Math.min(at,1-vis)*100)+'%';
    }
    rail.addEventListener('scroll',function(){requestAnimationFrame(prog)},{passive:true});
    window.addEventListener('resize',prog); setTimeout(prog,50);
    var pos=0, hold=0, inView=false, hover=false;
    function half(){ return touch?Infinity:rail.scrollWidth/2; }
    function tick(){
      if(!reduce && inView && !hover && Date.now()>hold){
        pos+=0.5; if(pos>=half()) pos-=half(); rail.scrollLeft=pos;
      } else { pos=rail.scrollLeft; if(pos>=half()) { pos-=half(); rail.scrollLeft=pos; } }
      requestAnimationFrame(tick);
    }
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){inView=e[0].isIntersecting},{threshold:0.2}).observe(rail); else inView=true;
    rail.addEventListener('mouseenter',function(){hover=true});
    rail.addEventListener('mouseleave',function(){hover=false});
    rail.addEventListener('focusin',function(){hover=true});
    rail.addEventListener('focusout',function(){hover=false});
    ['touchstart','pointerdown','wheel'].forEach(function(ev){ rail.addEventListener(ev,function(){hold=Date.now()+4000},{passive:true}); });
    $$('[data-idir]').forEach(function(b){b.addEventListener('click',function(){
      hold=Date.now()+2500;
      var c=rail.querySelector('.icard'), step=c?c.getBoundingClientRect().width+16:300;
      if(!touch && b.dataset.idir<0 && rail.scrollLeft<step){ rail.scrollLeft+=half(); }
      rail.scrollBy({left:Number(b.dataset.idir)*step,behavior:'smooth'});
    })});
    requestAnimationFrame(tick);
  })();

  /* ---------- shop now dropdown ---------- */
  var shopBtn=$('.nav-cta'), shopPanel=$('#shop-panel');
  function closeShopPanel(){ if(!shopPanel.hidden){shopPanel.hidden=true; shopBtn.setAttribute('aria-expanded','false');} }
  shopBtn.addEventListener('click',function(e){
    e.stopPropagation();
    var open=shopPanel.hidden; shopPanel.hidden=!open; shopBtn.setAttribute('aria-expanded',String(open));
  });
  document.addEventListener('click',function(e){ if(!e.target.closest('.shop-menu')) closeShopPanel(); });

  /* ---------- press marquee pause ---------- */
  var pm=$('.pm-toggle');
  if(pm) pm.addEventListener('click',function(){
    var paused=pm.getAttribute('aria-pressed')!=='true';
    pm.setAttribute('aria-pressed',String(paused));
    pm.setAttribute('aria-label',paused?'Play logo scroll':'Pause logo scroll');
    $('.press-marquee').classList.toggle('paused',paused);
  });

  /* ---------- PDP gallery ----------
     Shots and bottles each have their own set of listing images (data-fmt).
     Only the set for the selected format is shown, and switching formats
     jumps back to that set's first image. */
  var thumbs=$$('.pdp-thumb'), tiles=$$('.pdp-tile'), gi=0;
  function fmtNow(){ return body.getAttribute('data-format')==='bottles'?'bottles':'shots'; }
  function visThumbs(){ var f=fmtNow(); return thumbs.filter(function(t){return t.dataset.fmt===f}); }
  function showTile(i){
    var vt=visThumbs(); if(!vt.length) return;
    gi=(i+vt.length)%vt.length;
    var tgt=vt[gi].dataset.tile;
    thumbs.forEach(function(x){x.setAttribute('aria-selected',String(x===vt[gi]))});
    tiles.forEach(function(x){x.setAttribute('aria-hidden', x.dataset.tile===tgt?'false':'true')});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){showTile(visThumbs().indexOf(t))})});
  var lastFmt=fmtNow();
  new MutationObserver(function(){ var f=fmtNow(); if(f!==lastFmt){ lastFmt=f; showTile(0); var tr=$('.pdp-thumbs'); if(tr) tr.scrollLeft=0; } }).observe(body,{attributes:true,attributeFilter:['data-format']});
  $$('.stage-nav').forEach(function(b){b.addEventListener('click',function(){showTile(gi+Number(b.dataset.step))})});
  (function(){
    var st=$('.pdp-stage'), x0=null; if(!st) return;
    st.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    st.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) showTile(gi+(dx<0?1:-1)); x0=null; });
  })();

  /* ---------- ingredient tabs and flip cards ---------- */
  var tabs=$$('.ing-tab'), panels=$$('.ing-caption'), ingHero=$('#ing-hero');
  tabs.forEach(function(t){t.addEventListener('click',function(){
    tabs.forEach(function(x){x.setAttribute('aria-selected','false')}); t.setAttribute('aria-selected','true');
    panels.forEach(function(p){p.hidden=p.dataset.panel!==t.dataset.tab});
    if(ingHero && t.dataset.src){ ingHero.src=t.dataset.src; if(t.dataset.alt) ingHero.alt=t.dataset.alt; }
  })});
  $$('.ing-card[aria-expanded]').forEach(function(c){c.addEventListener('click',function(){
    c.setAttribute('aria-expanded', c.getAttribute('aria-expanded')==='true'?'false':'true');
  })});

  /* ---------- share ---------- */
  var shareBtn=$('#share-btn');
  if(shareBtn) shareBtn.addEventListener('click',function(){
    var data={title:'MonaVie is back', text:'The MonaVie you remember, now in a shot.', url:location.origin+location.pathname};
    if(navigator.share){ navigator.share(data).catch(function(){}); return; }
    if(navigator.clipboard) navigator.clipboard.writeText(data.url).then(function(){ $('#share-done').hidden=false; });
  });

  /* ---------- Klaviyo ---------- */
  var K=CONFIG.klaviyo;
  /* With the Klaviyo app embed on, the public id can be read from its script tag */
  if(!K.companyId){ var kt=document.querySelector('script[src*="klaviyo.js?company_id="],script[src*="klaviyo.js?"]'); var km=kt&&/company_id=([A-Za-z0-9]+)/.exec(kt.src); if(km) K.companyId=km[1]; }
  if(K.companyId && !window.klaviyo){
    var ks=document.createElement('script'); ks.async=true;
    ks.src='https://static.klaviyo.com/onsite/js/klaviyo.js?company_id='+encodeURIComponent(K.companyId);
    document.head.appendChild(ks);
    window._klOnsite=window._klOnsite||[];
  }
  function track(name,props){ try{ if(window.klaviyo) window.klaviyo.push(['track',name,props]); }catch(e){} }
  function absUrl(u){ return !u ? '' : (/^\/\//.test(u) ? 'https:'+u : (/^\//.test(u) ? location.origin+u : u)); }
  window.addEventListener('load',function(){
    if(!$('#widget')) return;
    track('Viewed Product',{ProductName:'MonaVie Active', Categories:['Shots','Bottles'], URL:location.href, ImageURL:absUrl('//monavie.shop/cdn/shop/t/22/assets/mv-listing-hero.jpg?v=102590966460728798931791313014')});
  });

  $$('[data-klaviyo-form]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var input=f.querySelector('input[type=email]'), msg=f.querySelector('.form-msg'), email=input.value.trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ msg.textContent='Please enter a valid email address.'; input.focus(); return; }
      var done=function(){ msg.textContent='Thank you. You are on the list.'; f.classList.add('done'); input.value=''; };
      try{ if(window.klaviyo) window.klaviyo.push(['identify',{'$email':email}]); }catch(err){}
      if(!K.companyId || !K.listId){ console.warn('Klaviyo ids missing, set them in Theme settings, MonaVie. Sign up not sent'); msg.textContent='Thanks. Email sign ups open very soon, so please check back.'; return; }
      msg.textContent='Signing you up...';
      fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(K.companyId),{
        method:'POST', headers:{'Content-Type':'application/vnd.api+json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Homepage sign up',profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:K.listId}}}}})
      }).then(function(r){ if(r.ok) done(); else throw 0; }).catch(function(){ msg.textContent='Something went wrong. Please try again.'; });
    });
  });

  Cart.load().then(renderCart,function(err){ console.error(err); renderCart(); });
})();
